<div>
  <form [formGroup]="formGroup">
    <div class="p-fluid formgrid grid align-items-end align-content-end">

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="exporterId">{{'AdminUsersManagement.CreateEditUser.IdLabel' | translate}}</label>
        <input id="exporterId" formControlName="exporterId" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="profileType">{{'AdminUsersManagement.CreateEditUser.RoleLabel' | translate}}</label>
        <input id="profileType" formControlName="profileType" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactName">{{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}</label>
        <input id="contactName" formControlName="contactName" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactEmail">{{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}</label>
        <input id="contactEmail" formControlName="contactEmail" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="vat">{{'AdminUsersManagement.CreateEditUser.VatIdLabel' | translate}}</label>
        <input id="vat" formControlName="vat" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="contactCity">{{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}</label>
        <input id="contactCity" formControlName="contactCity" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="country">{{'AdminUsersManagement.CreateEditUser.CountryLabel' | translate}}</label>
        <input id="country" formControlName="country" type="text" pInputText class="custom-input bg-form" />
      </div>

      <div class="field col-12 md:col-6 lg:col-4 xl:col-3">
        <label for="phone">{{'AdminUsersManagement.CreateEditUser.PhoneLabel' | translate}}</label>
        <input id="phone" formControlName="phone" type="text" pInputText class="custom-input bg-form" />
      </div>
    </div>
  </form>

  <div class="mt-4">
    <p-table [value]="importers"
      [paginator]="true"
      [rows]="5"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      stateStorage="session"
      stateKey="statedemo-session"
      class="custom-table">
      <ng-template pTemplate="header">
        <tr>
          <th>{{'AdminUsersManagement.CreateEditUser.IdLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.CompanyLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.VatIdLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.ContactNameLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.EmailLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.CityLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.CountryLabel' | translate}}</th>
          <th>{{'AdminUsersManagement.CreateEditUser.AssociatedLabel' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-importer>
        <tr>
          <td>{{ importer.id }}</td>
          <td>{{ importer.companyName }}</td>
          <td>{{ importer.vat }}</td>
          <td>{{ importer.contactName }}</td>
          <td>{{ importer.contactEmail }}</td>
          <td>{{ importer.contactCity }}</td>
          <td>{{ importer.country | countryDescription }}</td>
          <td>
            <p-inputSwitch [(ngModel)]="importer.isExporterAsociated" (onChange)="onToogleAsociation(importer.id, $event)"></p-inputSwitch>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="p-fluid formgrid grid mt-4">
    <div class="field col-12 md:col-offset-10 md:col-2 mt-3">
      <p-button
        label="{{'AdminUsersManagement.Messages.CloseButton' | translate}}"
        (onClick)="close()"
        styleClass="p-button-outlined"
        class="custom-text-button"/>
    </div>
  </div>

</div>

